export default (a) => a;
